import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import CardSection from "./CardSection";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/reservas",
    label: "Reservas por Tipo",
  },
  {
    path: "/reservas/hotel",
    label: "Reserva Hotel",
    isActive: true,
  },
];

function ReservasHotel() {
  return (
    <Page
      title="Reservas de Hotel"
      description="Acciones en reservas de Hotel."
      breadCrumbs={breadCrumbs}
    >
      <CardSection />
    </Page>
  );
}

export default ReservasHotel;
